import React from 'react';

import Typography from "@material-ui/core/Typography";

import {CommonLayout} from "../../layouts/CommonLayout/CommonLayout";
import {makeStyles} from "@material-ui/styles";
import {Grid} from "@material-ui/core";
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';

const useStyles = makeStyles(() => ({
    centeredDiv: {
        width: '100%',
        height: '100%',
    },
    smiley: {
        fontSize: 45
    }
}))


export const NotFoundPage = () => {
    const classes = useStyles()

    return <CommonLayout>
        <Grid
            container
            justifyContent={'center'}
            alignContent={'center'}
            direction={'column'}
            className={classes.centeredDiv}
        >
            <Grid item>
                <Typography variant={'h2'} align={'center'}><SentimentDissatisfiedIcon className={classes.smiley}/> 404</Typography>
            </Grid>
            <Grid item>
                <Typography variant={'h4'} align={'center'}>Страница не найдена</Typography>
            </Grid>
            <Grid item>
                <Typography variant={'body1'} align={'center'}>Проверьте адрес страницы</Typography>
            </Grid>
            <Grid item>
                <Typography variant={'body1'} align={'center'}>или выберите необходимый пункт в меню</Typography>
            </Grid>
        </Grid>
    </CommonLayout>
}